import { Box, TableCell, Tooltip } from '@mui/material';
import {
  IconContainer,
  StyledIconButton,
  TableRow,
} from 'FeatureModules/Partner/Components/PartnersTable/PartnersTableBody/PartnersTableBody.styles';
import { StyledTableBody } from 'Components/TableBase/Table';
import { ThemeTypography } from 'DesignSystem';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import React, { FC, MouseEvent } from 'react';
import Moment from 'react-moment';
import { IPlot } from 'FeatureModules/Site/types/plot.types';
import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';
import { EPlotsTableColumnKeys } from './plotsHeaderColumns';
import PlotTitle from '../PlotTitle';

interface IPlotsTableProps {
  plots: IPlot[];
  headerColumns: IHeaderColumn[];
  onEdit: (plot: IPlot) => void;
  onClick: (plot: IPlot) => void;
  onDelete?: (plot: IPlot) => void;
}

const PlotsTableBody: FC<IPlotsTableProps> = ({
  plots,
  headerColumns,
  onEdit,
  onClick,
  onDelete,
}) => {
  return (
    <StyledTableBody>
      {plots.map(plot => {
        const labelId = `plot-${plot.id}`;

        return (
          <TableRow
            hover
            id={labelId}
            key={labelId}
            onClick={(event: MouseEvent) => {
              event.stopPropagation();
              onClick(plot);
            }}
          >
            {headerColumns.map(({ id: columnId, align }) => {
              switch (columnId) {
                case EPlotsTableColumnKeys.TITLE: {
                  return (
                    <TableCell key={`${labelId}-${columnId}-title`} scope="row" align={align}>
                      <Box maxWidth="550px">
                        <PlotTitle plot={plot} />
                      </Box>
                    </TableCell>
                  );
                }

                case EPlotsTableColumnKeys.CREATED_TIMESTAMP: {
                  return (
                    <TableCell key={`${labelId}-${columnId}-created-at`} scope="row" align={align}>
                      <ThemeTypography variant="BODY_MEDIUM" color="GRAY_100">
                        <Moment format="MMMM DD, YYYY">{plot.createdTimestamp}</Moment>
                      </ThemeTypography>
                    </TableCell>
                  );
                }
                case EPlotsTableColumnKeys.ACTIONS: {
                  return (
                    <TableCell
                      key={`${labelId}-${columnId}-actions`}
                      width={100}
                      scope="row"
                      align={align}
                    >
                      <IconContainer>
                        {[
                          {
                            icon: <Icon name="edit" />,
                            tooltip: 'Edit plot',
                            onClick: onEdit,
                          },
                          {
                            icon: <Icon name="delete" />,
                            tooltip: 'Delete plot',
                            onClick: onDelete,
                          },
                        ].map((action, index) => {
                          return (
                            <Tooltip key={index} title={action.tooltip}>
                              <StyledIconButton
                                onClick={event => {
                                  event.stopPropagation();
                                  action.onClick?.(plot);
                                }}
                              >
                                {action.icon}
                              </StyledIconButton>
                            </Tooltip>
                          );
                        })}
                      </IconContainer>
                    </TableCell>
                  );
                }
                default:
                  return <></>;
              }
            })}
          </TableRow>
        );
      })}
    </StyledTableBody>
  );
};

export default PlotsTableBody;
